import React from "react";
import {
  // HashRouter as Router,
  Routes,
  Route,
  Navigate,
  BrowserRouter as Router,
  // HashRouter as Router,
} from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import LoginPage from "./pages/Login";
import ResetPwdPage from "./pages/Login/reset-pwd";
import MainLayout from "./components/Layout/MainLayout";
import WarehouseManagement from "./pages/WarehouseManagement";
import AccountManagement from "./pages/AccountManagement";
import AccountStoreAuthPage from "./pages/AccountManagement/AccountStoreAuthPage";
import AccountManagementHQ from "./pages/AccountManagement_HQ";
import AccountStoreAuthPageHQ from "./pages/AccountManagement_HQ/AccountStoreAuthPageHQ";
import RoleManagement from "./pages/RoleManagement";
import DataPermissionManagement from "./pages/DataPermissionManagement";
import Profile from "./pages/Profile";
import Settings from "./pages/Settings";
import ProtectedRoute from "./components/ProtectedRoute";
import MenuManagement from "./pages/MenuManagement";

import HQDisplayGroupList from "./pages/hq-display-group";
import HQDisplayGroupDetail from "./pages/hq-display-group/HQDisplayGroupDetail";
import HQDisplayGroupCreate from "./pages/hq-display-group/HQDisplayGroupCreate";
import HQDisplayGroupEdit from "./pages/hq-display-group/HQDisplayGroupEdit";
import StoreGroupList from "./pages/store-group/StoreGroupList";
import StoreGroupDetail from "./pages/store-group/StoreGroupDetail";
import StoreGroupForm from "./pages/store-group/StoreGroupForm";
import StoreDetail from "./pages/store-group/StoreDetail";
import BenchmarkView from "./pages/store-group/BenchmarkView";
import PlanogramForm from "./pages/store-group/PlanogramForm";
import PlanogramDetail from "./pages/store-group/PlanogramDetail";
import { ContainerList, ContainerFormPage } from "./pages/container";
import { FixtureList, FixtureDetail, FixtureFormPage } from "./pages/fixture";
import { CategoryList } from "./pages/category";
import SectionTypeList from "./pages/sectionType/SectionTypeList";
import SectionTypeDetail from "./pages/sectionType/SectionTypeDetail";
import SectionTypeFormPage from "./pages/sectionType/SectionTypeFormPage";
import { ShelfList, ShelfDetail } from "./pages/shelf";
import StoreDisplayGroupList from "./pages/store-display-group/StoreDisplayGroupList";
import StoreDisplayGroupDetail from "./pages/store-display-group/StoreDisplayGroupDetail";
import StoreDisplayGroupPlanogramView from "./pages/store-display-group/StoreDisplayGroupPlanogramView";
import StoreDisplayGroupPlanogramList from "./pages/store-display-group/StoreDisplayGroupPlanogramList";
import StoreDisplayGroupPlanogramDetail from "./pages/store-display-group/StoreDisplayGroupPlanogramDetail";
import FeedbackListPage from "./pages/task-management/FeedbackListPage.tsx";
import FeedbackList4StorePage from "./pages/task-management/FeedbackList4StorePage.tsx";

// 门店陈列分组计划图申请管理
import StoreGroupPlanogramApplyList from "./pages/sdg-planogram-apply/StoreGroupPlanogramApplyList";
import StoreGroupPlanogramApplyList4Plangram from "./pages/sdg-planogram-apply/StoreGroupPlanogramApplyList4Planogram";
import StoreGroupPlanogramApplyList4Operate from "./pages/sdg-planogram-apply/StoreGroupPlanogramApplyList4Operate";
import StoreDisplayGroupPlanogramApplyDetail from "./pages/sdg-planogram-apply/StoreDisplayGroupPlanogramApplyDetail";

import PlanogramPlanList from "./pages/plan/PlanogramPlanList";
import PlanogramPlanCalendar from "./pages/plan/PlanogramPlanCalendar";
import PersonnelAssignment from "./pages/plan/PersonnelAssignment";
import PlanActivation from "./pages/plan/PlanActivation";
import PlanDetail from "./pages/plan/PlanDetail";
import PlanogramTemplateList from "./pages/plan-template/PlanogramTemplateList";
import TemplateDetailWrapper from "./pages/plan-template/components/TemplateDetailWrapper.tsx";
import PageHeader from "./components/common/PageHeader";
import TallyTask from "./pages/task-management/index.tsx";
import TaskListPage from "./pages/task-management/TaskListPage.tsx";
import SubtaskList from "./pages/plan-sub-task/SubtaskList.tsx";
import SubtaskList4Worker from "./pages/plan-sub-task/SubtaskList4Worker";
import TaskCompletion from "./pages/plan-sub-task/TaskCompletion.tsx";
import SubtaskDetailWrapper from "./pages/plan-sub-task/SubtaskDetailWrapper.tsx";
import { ItemStoreRelationshipList } from "./pages/item-store-relationship";
import { StoreItemInventoryList } from "./pages/store-item-inventory";
import StoreItemSaleList from "./pages/store-item-sale/StoreItemSaleList";
import ItemLocationRelationshipList from "./pages/item-location-relationship/ItemLocationRelationshipList";
import OperatorGroupList from "./pages/operator-group/OperatorGroupList";
import OperatorGroupDetail from "./pages/operator-group/OperatorGroupDetail";
import OperatorGroupCreate from "./pages/operator-group/OperatorGroupFormPage";
import OperatorGroupEdit from "./pages/operator-group/OperatorGroupFormPage";
import PromotionLocationItemList from "./pages/promotion-location-item";
// import HemaIframe from "./pages/Hema";
import { ItemMasterDataList } from "./pages/item-master-data";

import SwitchWarehouse from "./pages/SwitchWarehouse";

import SharePage from "./pages/share";
import HemaPage from "./pages/hema-page";
import NotFound from "./pages/NotFound";
import Forbidden from "./pages/Forbidden";

import "./styles/hqDisplayGroup.css";
import "./styles/storeGroup.css";
import "./styles/containerFilterPanel.css";
import "./styles/fixture.css";
import "./styles/planogramTemplate.css";
import "./pages/sectionType/sectionType.css";
import "./styles/itemStoreRelationship.css";
import "./styles/storeItemInventory.css";
import "./styles/storeItemSale.css";
import "./styles/itemLocationRelationship.css";
import "./styles/operatorGroup.css";
import "./styles/storeDisplayGroupPlanogram.css";
import "./styles/storeDisplayGroupPlanogramList.css";
import "./styles/storeDisplayGroupPlanogramApply.css";
import "./styles/promotionLocationItem.css";
import "./styles/global.css";
import "./styles/App.css";

const App = () => {
  return (
    <AuthProvider>
      <Router basename="/">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/login/reset-pwd" element={<ResetPwdPage />} />
          <Route path="/404" element={<NotFound />} />
          <Route path="/403" element={<Forbidden />} />

          <Route
            path="/"
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/warehouse" replace />} />
            <Route path="warehouse" element={<WarehouseManagement />} />
            <Route path="account-management" element={<AccountManagement />} />
            <Route
              path="account-management/:loginId/store-auth"
              element={<AccountStoreAuthPage />}
            />
            <Route path="role" element={<RoleManagement />} />
            <Route
              path="data-permission"
              element={<DataPermissionManagement />}
            />

            <Route
              path="account-management-hq"
              element={<AccountManagementHQ />}
            />
            <Route
              path="account-management-hq/:loginId/store-auth"
              element={<AccountStoreAuthPageHQ />}
            />

            <Route path="profile" element={<Profile />} />
            <Route path="settings" element={<Settings />} />
            <Route path="menu" element={<MenuManagement />} />

            {/* 盒马算法路由 */}
            <Route path="alogrithm-configure" element={<HemaPage />} />

            {/* 总部陈列分组路由 */}
            <Route path="hq-display-groups" element={<HQDisplayGroupList />} />
            <Route
              path="hq-display-groups/create"
              element={<HQDisplayGroupCreate />}
            />
            <Route
              path="hq-display-groups/:code"
              element={<HQDisplayGroupDetail />}
            />
            <Route
              path="hq-display-groups/:code/edit"
              element={<HQDisplayGroupEdit />}
            />

            {/* 门店组管理路由 */}
            <Route path="store-group/list" element={<StoreGroupList />} />
            <Route
              path="store-group/create"
              element={<StoreGroupForm mode="create" />}
            />
            <Route path="store-group/:code" element={<StoreGroupDetail />} />
            <Route
              path="store-group/:code/edit"
              element={<StoreGroupForm mode="edit" />}
            />
            <Route
              path="store-group/:code/benchmark"
              element={<BenchmarkView />}
            />
            <Route
              path="store-group/:storeGroupCode/store/:storeId"
              element={<StoreDetail />}
            />

            {/* 陈列图路由 */}
            <Route
              path="store-group/:storeGroupCode/planogram/create"
              element={<PlanogramForm mode="create" />}
            />
            <Route
              path="store-group/:storeGroupCode/planogram/:code"
              element={<PlanogramDetail />}
            />
            <Route
              path="store-group/:storeGroupCode/planogram/:code/edit"
              element={<PlanogramForm mode="edit" />}
            />
            <Route
              path="store-group/:storeGroupCode/store/:storeId/planogram/create"
              element={<PlanogramForm mode="create" />}
            />
            <Route
              path="store-group/:storeGroupCode/store/:storeId/planogram/:code"
              element={<PlanogramDetail />}
            />
            <Route
              path="store-group/:storeGroupCode/store/:storeId/planogram/:code/edit"
              element={<PlanogramForm mode="edit" />}
            />

            {/* 托盘管理路由 */}
            <Route path="container/list" element={<ContainerList />} />
            <Route path="container/create" element={<ContainerFormPage />} />

            {/* 夹具管理路由 */}
            <Route path="fixture/list" element={<FixtureList />} />
            <Route
              path="fixture/create"
              element={<FixtureFormPage mode="create" />}
            />
            <Route
              path="fixture/edit/:id"
              element={<FixtureFormPage mode="edit" />}
            />
            <Route path="fixture/detail/:id" element={<FixtureDetail />} />

            {/* 类目管理路由 */}
            <Route path="category" element={<CategoryList />} />

            {/* 货架类型管理路由 */}
            <Route path="section-type" element={<SectionTypeList />} />
            <Route
              path="section-type/create"
              element={<SectionTypeFormPage />}
            />
            <Route
              path="section-type/edit/:id"
              element={<SectionTypeFormPage />}
            />
            <Route
              path="section-type/detail/:id"
              element={<SectionTypeDetail />}
            />

            {/* 货架管理路由 */}
            <Route path="shelf" element={<ShelfList />} />
            <Route path="shelf/detail/:id" element={<ShelfDetail />} />

            {/* 门店陈列分组路由 */}
            <Route
              path="store-display-groups"
              element={<StoreDisplayGroupList />}
            />
            <Route
              path="store-display-groups/:code"
              element={<StoreDisplayGroupDetail />}
            />
            <Route
              path="store-display-groups/:code/planogram"
              element={<StoreDisplayGroupPlanogramView />}
            />
            <Route
              path="store-display-groups/planogram/list"
              element={<StoreDisplayGroupPlanogramList />}
            />
            <Route
              path="store-display-groups/:storeDisplayGroupCode/planogram/:planogramCode/:source"
              element={<StoreDisplayGroupPlanogramDetail />}
            />

            {/* 实操 */}
            <Route path="execution" element={<TallyTask />} />

            {/* 任务列表页面 */}
            <Route path="task-list" element={<TaskListPage />} />

            {/* 计划路由 */}
            <Route path="plans" element={<PlanogramPlanList />} />
            <Route path="calendar" element={<PlanogramPlanCalendar />} />
            <Route path="assignment/:id" element={<PersonnelAssignment />} />
            <Route path="activation/:id" element={<PlanActivation />} />
            <Route path="detail/:id" element={<PlanDetail />} />

            {/* 货架图模板管理路由 */}
            <Route path="templates" element={<PlanogramTemplateList />} />

            {/* 创建模板页（使用向导） */}
            <Route
              path="templates/create"
              element={
                <div style={{ padding: "24px" }}>
                  <PageHeader
                    title="创建模板"
                    // showBack
                    onBack={() => window.history.back()}
                  />
                </div>
              }
            />

            {/* 模板详情页 */}
            <Route path="templates/:id" element={<TemplateDetailWrapper />} />

            {/* 编辑模板页（使用向导） */}
            <Route
              path="templates/:id/edit"
              element={
                <div style={{ padding: "24px" }}>
                  <PageHeader
                    title="编辑模板"
                    // showBack
                    onBack={() => window.history.back()}
                  />
                </div>
              }
            />

            {/* 计划子任务路由 */}
            <Route path="subtasks" element={<SubtaskList />} />
            <Route path="subtasks4Worker" element={<SubtaskList4Worker />} />
            <Route path="subtasks/:code" element={<SubtaskDetailWrapper />} />
            <Route
              path="subtasks/:subtaskCode/complete"
              element={<TaskCompletion />}
            />

            {/* 门店货品关系路由 */}
            <Route
              path="item-store-relationship"
              element={<ItemStoreRelationshipList />}
            />

            {/* 门店商品库存路由 */}
            <Route
              path="store-item-inventory"
              element={<StoreItemInventoryList />}
            />

            {/* 门店商品销量路由 */}
            <Route path="store-item-sale" element={<StoreItemSaleList />} />

            {/* 货品库位关系路由 */}
            <Route
              path="item-location-relationship"
              element={<ItemLocationRelationshipList />}
            />

            {/* 操作组管理路由 */}
            <Route path="operator-group" element={<OperatorGroupList />} />
            <Route
              path="operator-group/create"
              element={<OperatorGroupCreate mode="create" />}
            />
            <Route
              path="operator-group/edit/:code"
              element={<OperatorGroupEdit mode="edit" />}
            />
            <Route
              path="operator-group/detail/:code"
              element={<OperatorGroupDetail />}
            />
            <Route path="feedback-list" element={<FeedbackListPage />} />
            <Route
              path="feedback-list-4-store"
              element={<FeedbackList4StorePage />}
            />

            {/* 门店陈列分组计划图申请路由 */}

            <Route
              path="sg-planogram-apply"
              element={<StoreGroupPlanogramApplyList />}
            />
            <Route
              path="sg-planogram-apply-4-planogram"
              element={<StoreGroupPlanogramApplyList4Plangram />}
            />
            <Route
              path="sg-planogram-apply-4-operate"
              element={<StoreGroupPlanogramApplyList4Operate />}
            />
            <Route
              path="sdg-planogram-apply/:id"
              element={<StoreDisplayGroupPlanogramApplyDetail />}
            />

            {/* 促销位货品管理路由 */}
            <Route
              path="promotion-location-item"
              element={<PromotionLocationItemList />}
            />

            {/* 货品主数据 */}
            <Route path="item" element={<ItemMasterDataList />} />

            {/* 数字空间 */}
            <Route path="share" element={<SharePage />} />

            <Route path="switch-warehouse" element={<SwitchWarehouse />} />
          </Route>

          {/* 404 页面 - 捕获所有未匹配的路径 */}
          {/* <Route path="*" element={<NotFound />} /> */}
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
